import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {ErrorService} from '@app/services';
import {TextTranslatedSearchParams} from '../text-translated-search-params';
import {TextTranslatedService} from '../text-translated.service';
@Component({
  selector: 'hpf-text-translated-count',
  templateUrl: './text-translated-count.component.html'
})
export class TextTranslatedCountComponent implements OnInit {
  /** The filters */
  @Input() searchParams: TextTranslatedSearchParams = new TextTranslatedSearchParams();
  /** Count result */
  count: number;
  /** Load flag */
  loaded = false;
  /** Constructor */
  constructor(private textTranslatedService: TextTranslatedService,
              private errorService: ErrorService) {}
  /** Init */
  ngOnInit() {
    this.textTranslatedService.count(this.searchParams.toObject())
    .then((count) => {
      this.count = count;
      this.loaded = true;
    })
    .catch((error) => this.errorService.handle(error))
  }
}
